module.exports = __webpack_public_path__ + "images/unlisted-blue-d617fab2.svg";